module.exports = __webpack_public_path__ + "img/map-point-rotate.bb6b8e03.svg";